module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/big/4-0ad28f5ccd1f8c9f30552956164a75f4.webp";